import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import anime from 'animejs';

export default function CookieConsentBanner() {
    const [isVisible, setIsVisible] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        // Check if user has already made a choice
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            // Small delay to not overwhelm user immediately on load
            const timer = setTimeout(() => {
                setIsVisible(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const animateOut = (callback) => {
        setIsClosing(true);
        // You could add anime.js exit animation here if desired
        // For now simplistic CSS class transition logic or state delay
        setTimeout(() => {
            setIsVisible(false);
            callback();
        }, 300);
    };

    const handleAcceptAll = () => {
        localStorage.setItem('cookieConsent', 'all');
        localStorage.setItem('cookieConsentDate', new Date().toISOString());
        animateOut(() => { });
    };

    const handleNecessaryOnly = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        localStorage.setItem('cookieConsentDate', new Date().toISOString());
        animateOut(() => { });
    };

    if (!isVisible) return null;

    return (
        <div
            className={`fixed bottom-4 right-4 z-[100] max-w-[calc(100vw-2rem)] sm:max-w-sm w-full transition-all duration-500 ease-out ${isClosing ? 'opacity-0 translate-y-8' : 'opacity-100 translate-y-0'}`}
        >
            <div className="bg-surface/95 backdrop-blur-xl border border-white/10 shadow-2xl rounded-2xl p-5 flex flex-col gap-4 pointer-events-auto ring-1 ring-black/5">
                <div>
                    <div className="flex items-center gap-3 mb-2">
                        <span className="text-2xl">🍪</span>
                        <h3 className="text-white font-bold text-lg">Cookies</h3>
                    </div>
                    <p className="text-text-secondary text-sm leading-relaxed">
                        We use cookies to ensure you get the best experience on our website.
                        <NavLink to="/cookies" className="ml-1 text-accent hover:underline decoration-accent/50 underline-offset-2">Read Cookie Policy</NavLink>.
                    </p>
                </div>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={handleNecessaryOnly}
                        className="px-3 py-2 rounded-lg text-xs font-medium text-text-secondary hover:text-white bg-white/5 hover:bg-white/10 border border-white/10 transition-all duration-200"
                    >
                        Necessary
                    </button>
                    <button
                        onClick={handleAcceptAll}
                        className="px-4 py-2 rounded-lg text-xs font-semibold text-white bg-accent hover:bg-accent/90 shadow-lg shadow-accent/20 hover:shadow-accent/40 transform hover:-translate-y-0.5 transition-all duration-200"
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    );
}
